import { render } from "./DetailsComposition.vue?vue&type=template&id=0ad04b44&ts=true"
import script from "./DetailsComposition.vue?vue&type=script&lang=ts"
export * from "./DetailsComposition.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__